import React from "react";
import { Phone, MessageCircle, Hand, Heart, Scroll, Home, Skull, Briefcase, Users, Zap } from "lucide-react";
import { CONTACT, SERVICES } from "../mock";

const ICONS = {
  "fa-hand": Hand,
  "fa-heart": Heart,
  "fa-scroll": Scroll,
  "fa-house-chimney": Home,
  "fa-skull-crossbones": Skull,
  "fa-briefcase": Briefcase,
  "fa-people-roof": Users,
  "fa-bolt": Zap,
};

const Services = () => {
  const wa = CONTACT.whatsappNumber.replace(/\D/g, "");
  return (
    <section id="services" className="services">
      <div className="container">
        <div className="services-head">
          <span className="section-label center">Our Expertise</span>
          <h2 className="section-title">
            Astrological Services<br/>Tailored for <em>Your Life</em>
          </h2>
          <p className="section-desc" style={{ margin: "14px auto 0" }}>
            Comprehensive spiritual guidance covering all aspects of your journey — career,
            relationships, family and inner well-being.
          </p>
        </div>

        <div className="services-grid">
          {SERVICES.map((s) => {
            const Icon = ICONS[s.icon] || Hand;
            return (
              <div className="service-card" key={s.id}>
                <div className="service-card-img">
                  <img src={s.img} alt={s.title} loading="lazy" />
                  <div className="service-card-icon"><Icon size={18} /></div>
                </div>
                <div className="service-card-body">
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <div className="service-card-actions">
                    <a href={`tel:${CONTACT.callNumber}`} className="btn btn-call"><Phone size={14}/> Call Now</a>
                    <a href={`https://wa.me/${wa}?text=Hi Guruji, I need guidance for ${encodeURIComponent(s.title)}`} target="_blank" rel="noreferrer" className="btn btn-wa"><MessageCircle size={14}/> WhatsApp</a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
